import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Typography from "@material-ui/core/Typography";

import IdeaChip from './IdeaChip';

const cardWidth = 320

const useStyles = makeStyles({
    root: {
        width: cardWidth
    },
    media: {
        // fix to 16:9
        width: cardWidth,
        height: cardWidth * 9/16,
        display: props => props.textOnlyMode? "none": "block",
    },
    cardSpecArea: {
        display: props => props.imageOnlyMode? "none": "block",
        padding: "12px",
        '&:last-child': {
            paddingBottom: "12px"
        }
    },
    wikiLink: {
        marginTop: "8px"
    },
    holdButton: {
        marginTop: "8px",
        marginLeft: "4px"
    }
});

export default function SupportCard(props) {
    const classes = useStyles(
        {
            imageOnlyMode: props.imageOnlyMode,
            textOnlyMode: props.textOnlyMode
        }
    );
    const cardInfo = props.card;
    const openWikiLink = () => {
        window.open('https://wikiwiki.jp/shinycolors/' + cardInfo.cardName, '_blank', 'noreferrer');
    }
    const holdMe = () => {
        props.onHold(cardInfo.cardName);
    }

    return (
        <Card className={classes.root}>
            <CardMedia
                className={classes.media}
                image={'cardImages/' + cardInfo.cardName + '.jpg'}
                title={cardInfo.cardName}
            />
            <CardContent className={classes.cardSpecArea}>
                <Typography variant="body2" gutterBottom>
                    {cardInfo.cardName}
                </Typography>
                <IdeaChip ideaData={cardInfo.getChipData()} />
                <Button
                    size="small"
                    onClick={openWikiLink}
                    className={classes.wikiLink}
                    variant="outlined"
                    color="primary"
                    startIcon={<OpenInNewIcon />}>
                        攻略Wiki
                </Button>
                <Button
                    size="small"
                    onClick={holdMe}
                    className={classes.holdButton}
                    variant={props.isHold? "contained": "outlined"}
                    color="secondary"
                    startIcon={props.isHold? <LockIcon/>: <LockOpenIcon/>}>
                        ホールド
                </Button>
            </CardContent>
        </Card>
    );
}
